export default "__VITE_ASSET__DmE2NjBu__"